<h2 mat-dialog-title>Select File...</h2>
<br>
<mat-dialog-content>
    <input #fileCtrl type="file" id="fileSelector" [accept]="accept" (change)="onSelectedFileChange($event)"
        class="file-input" />
    <div fxLayout="row" class="file-upload" style="width: 100%;">
        <div fxFlex="90" fxLayoutAlign="start center">
            {{fileCtrl?.files[0]?.name || "No file uploaded yet."}}
        </div>

        <div fxLayoutAlign="end end">
            <button mat-mini-fab color="" class="upload-btn" (click)="fileCtrl.click()">
                <mat-icon>attach_file</mat-icon>
            </button>
        </div>
    </div>
    <small>Accepted Files: {{accept}}</small>
    @if(error) {
    <mat-error>{{error}}</mat-error>
    }
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button color="warn" [mat-dialog-close]="null">{{data.cancelText}}</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="fileCtrl.files"
        [disabled]="!selectionValid">{{data.confirmText}}</button>
</mat-dialog-actions>